module.exports = __webpack_public_path__ + "img/icon_wy13.ce1dd6ca.png";